import React from "react";
import { Link } from "react-router-dom";
import { Lines, FadeUp } from "../components/Reveal";

export default function PaymentCancel() {
    return (
        <div data-testid="payment-cancel-page" className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
            <p className="text-[9px] uppercase tracking-[0.4em] text-[#6B6A66]">Payment Cancelled</p>
            <h1 className="font-display mt-6 text-4xl font-black uppercase tracking-tighter text-[#0A0A0A] sm:text-6xl">
                <Lines lines={["Your Bag", "Is Waiting."]} />
            </h1>
            <FadeUp delay={0.3}>
                <p className="mt-8 max-w-sm text-xs leading-relaxed text-[#8E8D8A]">
                    Nothing was charged. Your pieces are still in your bag whenever you're ready.
                </p>
                <Link
                    data-testid="cancel-back-to-checkout"
                    to="/checkout"
                    className="link-underline mt-10 inline-block font-display text-[11px] font-bold uppercase tracking-[0.35em] text-[#0A0A0A]"
                >
                    Back To Checkout
                </Link>
            </FadeUp>
        </div>
    );
}
